import { setProfile, usePJStore, useProfile, useProfiles, useUserInfo } from '@jaf/jaf-react-core';
import React, { useEffect, useRef, useState } from 'react'
import { Route, Switch, useHistory, BrowserRouter as Router } from 'react-router-dom'
import ChatbotRestyled from '../components/Chatbot/ChatbotRestyled'
import GestioneConfigurazioni from '../components/GestioneConfigurazioni/GestioneConfigurazioni'
import HomePage from '../components/HomePage/HomePage'
import ModificaConfigurazione from '../components/ModificaConfigurazione/Modificaconfigurazione'
import ReactInoltraFormConfig from '../components/NuovaRichiesta/Forms/ReactInoltraFormConfig/ReactInoltraFormConfig'
import EmptyComponent from '../components/Chatbot/EmptyComponent'
import CareerServiceForm from '../components/NuovaRichiesta/Forms/CareerService/CareerServiceForm'
import DottorandiForm from '../components/NuovaRichiesta/Forms/Dottorandi/DottorandiForm';

const App = (props) => {

  const params = usePJStore((state) => state.params)

  const isLogged = useUserInfo() != null;

  const history = useHistory();

  const profile = useProfile();
  const profiles = useProfiles();

  //internazionalizzazione
  const getText = usePJStore((state) => state.i18n_getText)





  const [redirectPath, setRedirectPath] = useState(sessionStorage.getItem("postLoginRedirect"));

  const ranOnce = useRef(false);
  useEffect(() => {

    if (ranOnce.current) return;
    ranOnce.current = true;
    // side-effect sicuro da eseguire una sola volta


  }, []);

  useEffect(() => {

    if (props.redirectPath && isLogged) {
      sessionStorage.removeItem("postLoginRedirect");

      if (isLogged && props.redirectPath.includes("/dottorandi") && profiles != null && profiles.length > 0 && profile == null) {
        console.log("profiles: ", profiles);
        setProfile(profiles.filter(p => p.profile == 5)[0]);
      }

      history.replace(props.redirectPath);
    }

  }, [props.redirectPath, isLogged, history, profiles]);

  console.log("profile: ", profile);
  const notGestore = profile == undefined || profile == null || (profile != null && profile.profile !== 2);
  console.log("notGestore: ", notGestore);
  const gestore = !notGestore;
  console.log("gestore: ", gestore);

  return (

    <Switch>
      <Route path='/careerservice'>
        <CareerServiceForm />
      </Route>


      <Route path='/dottorandiForm'>
        <DottorandiForm />
      </Route>

      <Route path='/faqpersonale'>
        {notGestore &&
          <ChatbotRestyled idConfig={114} />
        }
      </Route>

      <Route path='/dottorandi'>
        {notGestore &&
          <ChatbotRestyled idConfig={120} />
        }
      </Route>

      <Route path='/studenti'>
        {notGestore &&
          <ChatbotRestyled idConfig={48} />
        }
      </Route>

      
        <Route exact path='/gestioneConfigurazioni' component={GestioneConfigurazioni} />
        <Route exact path='/modificaConfigurazione' component={ModificaConfigurazione} />
        <Route path='/' component={HomePage} />
      





      {params.nuovaRichiesta &&
        <>
          {params.formType == 'ReactInoltraFormConfig' &&
            <Route path='*' component={ReactInoltraFormConfig} />
          }
        </>
      }







    </Switch>
  )
}


export default App
